import React, { Component, Fragment } from 'react'
import '../../styles/Popup.module.css'
import {
    Form,
    Select,
    Input,
    Button,
    Upload,
    Row,
    Col,
    Checkbox,
    Radio,
} from 'antd';
import ImgCrop from 'antd-img-crop';
import ReactDropzone from "react-dropzone";
import { connect } from 'react-redux';
import { requestServerPost, selectBrand, selectPage } from '../../actions';

import { UploadOutlined, InboxOutlined } from '@ant-design/icons';
import PopupManager from '../../managers/PopupManager';
import path from 'path';
import LayoutTemplates from '../../data/LayoutTemplates';
import ColorPicker from '../ColorPicker';
import Colors from '../../config/Colors';

const { Option } = Select;

const formItemLayout = {
    labelCol: { span: 0 },
    wrapperCol: { span: 24 },
};

class CreateEventTimelinePage extends Component {
    constructor(props) {
        super(props);
        const { data = null } = props;

        const timelineName = data ? data.TimelineName : ""
        const eventType = data ? data.EventType : ""

        if (!data || !data.BrandLogo || data.BrandLogo === "") {
            this.state = {
                timelinename: timelineName, fileList: [], files: [], data: data
            };

            return
        }

        this.state = {
            timelinename: timelineName, data: data, color: null, eventtype: eventType
        };
    }


    componentDidMount() {
        const { data = null } = this.props;

        if (data)
            this.setState({ color: (data.Color ? data.Color : Colors.defaulttimeline) });
        else
            this.setState({ color: Colors.defaulttimeline });

    }
    createTimelineLayout = (timelineID) => {
        const { requestServerPost, usertoken, data = null, selectedBrandData, campaignData } = this.props;
        return new Promise((resolve, reject) => {
            var params = new FormData();
            params.append("brandid", selectedBrandData.BrandID);
            params.append("timelineid", timelineID);
            params.append("layout", JSON.stringify(LayoutTemplates.templates[0]));
            params.append("duration", 0);
            requestServerPost("create_timelinelayout", params, {}, (response) => {
                resolve();
            }, usertoken);
        })
    }
    onFinish = values => {
        const { requestServerPost, usertoken, data = null, selectedBrandData, campaignData } = this.props;
        var params = new FormData();

        // console.log("campaignData " + JSON.stringify(campaignData))
        const { CampaignID } = campaignData

        params.append("campaignid", CampaignID)

        if (!data) {
            params.append("brandid", selectedBrandData.BrandID);
            params.append("timelinename", values.timelinename);
            params.append("color", this.state.color);

            requestServerPost("create_timeline", params, {}, (response) => {
                const { timelineid } = response.data

                this.createTimelineLayout(timelineid).then(() => { PopupManager.closePopup() })

            }, usertoken);
        }
        else {
            params.append("brandid", selectedBrandData.BrandID);
            params.append("timelineid", data.TimelineID);
            params.append("timelinename", values.timelinename);
            params.append("color", this.state.color);

            requestServerPost("update_timeline", params, {}, (response) => {
                PopupManager.closePopup();
            }, usertoken);
        }
    };

    onColorChanged = (newcolor) => {
        this.setState({ color: newcolor });
    }
    render() {
        const { data = null } = this.props;
        const previewStyle = {
            display: 'inline',
            width: 100,
            height: 100,
        };
        const color = data ? (data.Color ? data.Color : Colors.defaulttimeline) : Colors.defaulttimeline;
        return (
            <div className="popupcontentcontainer" style={{ height: "100%" }}>
                <Row style={{ width: "100%", height: "100%", padding: "24px" }}>
                    <Col span={12} style={{ padding: "40px" }}>
                        <div style={{ fontSize: 38, fontWeight: 400, lineHeight: "42px", width: "300px", margin: "0 0 30px 0" }}>
                            {data ? "Edit Event Timeline Information" : "Let's Create a New Event-Based Timeline"}
                        </div>
                        <Form
                            name="validate_other"
                            {...formItemLayout}
                            onFinish={this.onFinish}
                            initialValues={{
                                ['timelinename']: this.state.timelinename,
                            }}
                        >
                            <Form.Item
                                name="timelinename"
                                label="What's the name of your timeline?"
                                rules={[{ required: true, message: 'Please input timeline name!' }]}
                            >
                                <Input placeholder="Timeline Name *" style={{ width: "250px" }} onChange={(e) => {
                                    this.setState({ timelinename: e.target.value })
                                }} />
                            </Form.Item>
                            <Form.Item
                                name="eventtype"
                                label="when should this timeline be triggered?"
                                rules={[{ required: true, message: 'Please select an event!' }]}
                            >
                                <Select
                                    placeholder="Select an event"
                                    onChange={(value) => {
                                        this.setState({ eventtype: value })
                                    }}
                                    allowClear
                                >
                                    <Option value="motion_detected">Motion Detected</Option>
                                </Select>
                            </Form.Item>
                            <Form.Item
                                name="allowinterruption"
                                label="Can new events interrupt this timeline while playing?"
                            >
                                <Radio.Group defaultValue="false">
                                    <Radio value="true">Yes</Radio>
                                    <Radio value="false">No</Radio>
                                </Radio.Group>
                            </Form.Item>
                            <Form.Item
                                name="duration"
                                label="Specify play duration (seconds)"
                            >
                                <Input placeholder="Duration" style={{ width: "250px" }} onChange={(e) => {
                                    // this.setState({ timelinename: e.target.value })
                                }} />
                            </Form.Item>
                            <Form.Item
                                name="duration"
                                label="After ended, new events have to wait for... (seconds)"
                            >
                                <Input placeholder="Duration" style={{ width: "250px" }} onChange={(e) => {
                                    // this.setState({ timelinename: e.target.value })
                                }} />
                            </Form.Item>
                            {/* <Form.Item
                                name="brandcode"
                                rules={[{ required: true, message: 'Please input brand code!' }]}
                            >
                                <Input placeholder="Brand Code *" />
                            </Form.Item> */}
                            <Form.Item
                                label="Pick timeline color" wrapperCol={{ span: 12 }} style={{}}>
                                <ColorPicker color={color} onColorChange={this.onColorChanged}></ColorPicker>
                            </Form.Item>

                            <Form.Item wrapperCol={{ span: 12 }} style={{ marginTop: "20px" }}>
                                <Button type="primary" htmlType="submit" style={{ width: "100%" }}>
                                    {data ? "Update" : "Create"}
                                </Button>
                            </Form.Item>
                        </Form>
                    </Col>
                    <Col span={12} style={{ float: "right" }}>
                        <img style={{ bottom: 0, right: 0, width: "100%", height: "100%", objectFit: "contain" }} src="/cms/assets/svgs/decorations/decorate_createtimeline.svg"></img>
                    </Col>
                </Row>
            </div >
        );
    }
}

const Styles = {

}


const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, selectedBrandData: state.selectedBrandData };
}

export default connect(mapStateToProps, { requestServerPost, selectPage })(CreateEventTimelinePage);
